<template>
  <div class="flex flex-col sm:grid gap-6 md:gap-8 xl:gap-12 sm:grid-cols-12">
    <div class="flex flex-col justify-center items-start order-2 sm:col-span-6 lg:col-span-5 sm:order-1 gap-4 lg:gap-6 xl:gap-8 2xl:gap-12">
      <slot />
    </div>
    <div class="order-1 sm:col-span-6 lg:col-span-7 sm:order-2 flex items-start">
      <MoleculePicture :image="image" class="w-full block rounded-xl overflow-hidden" />
    </div>
  </div>
</template>

<script setup lang="ts">
interface Props {
  image: object
}

defineProps<Props>()
</script>
